import { Ref, ref } from "vue";
import { useCookies as defaultUseCookies } from "vue3-cookies";

export type CookieConsent = {
  "strictly-necessary"?: boolean,
  functionality?: boolean,
  targeting?: boolean,
  tracking?: boolean
};

export type ReactiveCookieConsent = {
  strictlyNecessary: Ref<boolean>,
  functionality: Ref<boolean>,
  targeting: Ref<boolean>,
  tracking: Ref<boolean>,
  accepted: Ref<boolean>
};


// These refs are intentionally global - if they changes for ANY 'use', we want to change it for ALL uses.
const functionality = ref<boolean>(false);
const strictlyNecessary = ref<boolean>(false);
const targeting = ref<boolean>(false);
const tracking = ref<boolean>(false);
const accepted = ref<boolean>(false);

export function setupCookieConsent() {
  
  document.addEventListener('DOMContentLoaded', function () {
    // @ts-ignore
    cookieconsent.run({
      "notice_banner_type":"simple",
      "consent_type":"express",
      "palette":"light",
      "language":"en",
      "page_load_consent_levels":[
        "strictly-necessary",
        "functionality",
        "tracking",
        "targeting"
      ],
      "notice_banner_reject_button_hide":false,
      "preferences_center_close_button_hide":false,
      "page_refresh_confirmation_buttons":false,
      "website_name":"https://epicroadtripplanner.com",
      "website_privacy_policy_url":"https://epicroadtripplanner.com/privacy"});
  
      const { 
        strictlyNecessary,
        functionality,
        targeting,
        tracking
       } = useCookieConsent();
  
      function logCookieConsent() {
        console.log('strictlyNecessary cookie consent:', strictlyNecessary.value);
        console.log('functionality cookie consent:', functionality.value);
        console.log('tracking cookie consent:', tracking.value);
        console.log('targeting cookie consent:', targeting.value);
      }
  
      function agreeCookieConsent() {
        console.log('CookieConsent agree.');
        useCookieConsent();
        logCookieConsent();
      }
  
      function rejectCookieConsent() {
        console.log('CookieConsent reject.');
        useCookieConsent();
        logCookieConsent();
      }
  
      function changeCookieConsent() {
        var saveButtons = Array.from(document.getElementsByClassName("cc-cp-foot-save"));
        for (let saveButton of saveButtons) {
          saveButton.addEventListener('click', saveCookieConsent, false);
        }
      }
  
      function saveCookieConsent() {
        console.log('CookieConsent save.');
        useCookieConsent();
        logCookieConsent();
      }
  
      var agreeButtons = Array.from(document.getElementsByClassName("cc-nb-okagree"));
      for (let agreeButton of agreeButtons) {
        agreeButton.addEventListener('click', agreeCookieConsent, false);
      }
      
      var rejectButtons = Array.from(document.getElementsByClassName("cc-nb-reject"));
      for (let rejectButton of rejectButtons) {
        rejectButton.addEventListener('click', rejectCookieConsent, false);
      }
  
      var changeButtons = Array.from(document.getElementsByClassName("cc-nb-changep"));
      for (let changeButton of changeButtons) {
        changeButton.addEventListener('click', changeCookieConsent, false);
      }    
  });
  
}

export function useCookieConsent(useCookies = defaultUseCookies): ReactiveCookieConsent {
  const { cookies } = useCookies();

  const latestCookieConsentAccepted = cookies.get('cookie_consent_user_accepted') === "true";
  const latestCookieConsent = (cookies.get('cookie_consent_level') || {}) as unknown as CookieConsent;

  // If it didn't change, don't touch it - it's reactive! Also isolate that funky !! syntax...
  function coerceUncertainty(ours: Ref<boolean>, theirs?: boolean) {
    if (ours.value != !!theirs) ours.value = !!theirs;
  }

  // We must be certain. If we don't know, we now know no.
  coerceUncertainty(accepted, latestCookieConsentAccepted);
  coerceUncertainty(strictlyNecessary, latestCookieConsent["strictly-necessary"]); // for strictly necessary cookies, doesn't matter if they've accepted yet
  coerceUncertainty(functionality, latestCookieConsentAccepted && latestCookieConsent?.functionality);  
  coerceUncertainty(targeting, latestCookieConsentAccepted && latestCookieConsent?.targeting);
  coerceUncertainty(tracking, latestCookieConsentAccepted && latestCookieConsent?.tracking);

  return { functionality, strictlyNecessary, targeting, tracking, accepted };

}

export function updateCookieConsent(useCookies = defaultUseCookies) {
  const { cookies } = useCookies();

  cookies.set('cookie_consent_level', {
    functionality: functionality.value,
    "strictly-necessary": strictlyNecessary.value,
    targeting: targeting.value,
    tracking: tracking.value
  } as unknown as string);

}